// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__hnVrU","footer":"ModalCreateQualiphyProcedure_footer__1JfLj","additionData":"ModalCreateQualiphyProcedure_additionData__1wXdM"};